import { hashDataAndSetForGtm } from '~/utils/hashDataAndSetForGtm'

const safeRequestIdleCallback = (callback: () => void) => {
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    window.requestIdleCallback(callback, { timeout: 1000 })
  } else {
    setTimeout(callback, 1)
  }
}

export const useTracking = () => {
  const route = useRoute()
  const { $gtm } = useNuxtApp()
  const { locale } = useI18n()
  const { authUserIdTracking, authenticated } = useAuth()
  const { currency, userType } = useUser()

  const pageType = computed(() => $gtm.pageType.value)

  // TRACKEVENT
  const trackEvent = async ({
    category,
    event,
    label,
    hash,
    ...rest
  }: {
    category?: string
    event: string
    label?: string | Record<string, string>
    hash?: {
      email?: string
      phone?: string
    }
    [x: string]: unknown
  }) => {
    if (!import.meta.client) return

    if (hash && Object.values(hash).length > 0) {
      await hashDataAndSetForGtm(hash)
    }

    let labelProperties = label || ''

    if (typeof labelProperties === 'object') {
      const keys = Object.keys(labelProperties)
      const result = keys.map((key) => {
        return `${key}:${labelProperties[key as keyof typeof labelProperties]}`
      })

      labelProperties = result.join(', ') as unknown as Record<string, string>
    }

    safeRequestIdleCallback(() => {
      $gtm.dataLayer.value.push({
        category,
        event,
        label: labelProperties,
        ...rest,
      })
    })
  }

  const trackPageViewErrorPage = () => {
    if (!import.meta.client) return

    safeRequestIdleCallback(() => {
      $gtm.dataLayer.value.push({
        currency: currency.value,
        'content-name': route.fullPath,
        event: 'page_view',
        locale: locale.value,
        logged_in: authenticated.value,
        page_type: 'error 404',
        user_lc_id: authUserIdTracking.value,
        user_type: userType.value,
      })
    })
  }

  return {
    pageType,
    trackEvent,
    trackPageViewErrorPage,
  }
}
